module.exports = {
	"_args": [
		[
			{
				"raw": "websocket@^1.0.23",
				"scope": null,
				"escapedName": "websocket",
				"name": "websocket",
				"rawSpec": "^1.0.23",
				"spec": ">=1.0.23 <2.0.0",
				"type": "range"
			},
			"/Users/xiuwenlu/Desktop/ToDo/ToDoApp/todo-app/node_modules/skygear-core"
		]
	],
	"_from": "websocket@>=1.0.23 <2.0.0",
	"_id": "websocket@1.0.24",
	"_inCache": true,
	"_location": "/websocket",
	"_nodeVersion": "7.3.0",
	"_npmOperationalInternal": {
		"host": "packages-12-west.internal.npmjs.com",
		"tmp": "tmp/websocket-1.0.24.tgz_1482977757939_0.1858439394272864"
	},
	"_npmUser": {
		"name": "theturtle32",
		"email": "brian@worlize.com"
	},
	"_npmVersion": "3.10.10",
	"_phantomChildren": {},
	"_requested": {
		"raw": "websocket@^1.0.23",
		"scope": null,
		"escapedName": "websocket",
		"name": "websocket",
		"rawSpec": "^1.0.23",
		"spec": ">=1.0.23 <2.0.0",
		"type": "range"
	},
	"_requiredBy": [
		"/skygear-core"
	],
	"_resolved": "https://registry.npmjs.org/websocket/-/websocket-1.0.24.tgz",
	"_shasum": "74903e75f2545b6b2e1de1425bc1c905917a1890",
	"_shrinkwrap": null,
	"_spec": "websocket@^1.0.23",
	"_where": "/Users/xiuwenlu/Desktop/ToDo/ToDoApp/todo-app/node_modules/skygear-core",
	"author": {
		"name": "Brian McKelvey",
		"email": "brian@worlize.com",
		"url": "https://www.worlize.com/"
	},
	"browser": "lib/browser.js",
	"bugs": {
		"url": "https://github.com/theturtle32/WebSocket-Node/issues"
	},
	"config": {
		"verbose": false
	},
	"contributors": [
		{
			"name": "Iñaki Baz Castillo",
			"email": "ibc@aliax.net",
			"url": "http://dev.sipdoc.net"
		}
	],
	"dependencies": {
		"debug": "^2.2.0",
		"nan": "^2.3.3",
		"typedarray-to-buffer": "^3.1.2",
		"yaeti": "^0.0.6"
	},
	"description": "Websocket Client & Server Library implementing the WebSocket protocol as specified in RFC 6455.",
	"devDependencies": {
		"buffer-equal": "^1.0.0",
		"faucet": "^0.0.1",
		"gulp": "git+https://github.com/gulpjs/gulp.git#4.0",
		"gulp-jshint": "^2.0.4",
		"jshint": "^2.0.0",
		"jshint-stylish": "^2.2.1",
		"tape": "^4.0.1"
	},
	"directories": {
		"lib": "./lib"
	},
	"dist": {
		"shasum": "74903e75f2545b6b2e1de1425bc1c905917a1890",
		"tarball": "https://registry.npmjs.org/websocket/-/websocket-1.0.24.tgz"
	},
	"engines": {
		"node": ">=0.8.0"
	},
	"gitHead": "0e15f9445953927c39ce84a232cb7dd6e3adf12e",
	"homepage": "https://github.com/theturtle32/WebSocket-Node",
	"keywords": [
		"websocket",
		"websockets",
		"socket",
		"networking",
		"comet",
		"push",
		"RFC-6455",
		"realtime",
		"server",
		"client"
	],
	"license": "Apache-2.0",
	"main": "index",
	"maintainers": [
		{
			"name": "theturtle32",
			"email": "brian@worlize.com"
		}
	],
	"name": "websocket",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/theturtle32/WebSocket-Node.git"
	},
	"scripts": {
		"gulp": "gulp",
		"install": "(node-gyp rebuild 2> builderror.log) || (exit 0)",
		"test": "faucet test/unit"
	},
	"version": "1.0.24"
};


//////////////////
// WEBPACK FOOTER
// ./~/websocket/package.json
// module id = 262
// module chunks = 0